<template lang="pug">
  div.marginTop(v-if="cadastro.informacaoDesejada")
    el-row(type='flex' :gutter="30")
      el-col.container-input(:md="12", :sm="24")
        validation-provider(rules="required", v-slot="{ errors }", name="Tipo informação desejada", mode="lazy")
          app-label(label="Selecione o tipo de informação desejada:", :required="true")
          el-select.input(
            class="select",
            v-model="cadastro.informacaoDesejada.tipoInformacao",
            placeholder="Selecione",
            value-key="codigo",
            name="tipoInformacao",
            :class="{'erro' : errors.length}"
          )
            el-option(
              v-for="item in tiposInformacao",
              :key="item.codigo",
              :label="item.descricao",
              :value="item"
            )
          span.help.erro {{ errors[0] }}
      el-col.container-input(v-if="cadastro.informacaoDesejada.tipoInformacao && cadastro.informacaoDesejada.tipoInformacao.codigo == 'OUTRO'" :span="16")
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Descrição:")
          el-input.input(
            name='Descrição',
            maxlength="300",
            v-model="cadastro.informacaoDesejada.descricaoOutro",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
    el-col.container-input
      validation-provider(rules="required", v-slot="{ errors }", name="Justificativa", mode="eager")
        app-label(label="Justificativa de solicitação:", :required="true")
        app-text-editor(
          v-model="cadastro.informacaoDesejada.justificativa"
          :class="{'input erro': errors && errors.length > 0 ? true : false}"
          :config="config"
        )
        span.help.erro {{ errors[0] }}
</template>

<script>
import AppTextEditor from '@/components/AppTextEditor'
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppTextEditor,
    AppLabel
  },

  props: ['cadastro'],

  data () {
    return {
      tiposInformacao: [
        {
          codigo: 'JURISDICAO_AREA',
          descricao: 'Juridição de área'
        },
        {
          codigo: 'AUTENTICIDADE_DOCUMENTOS',
          descricao: 'Autenticidade de documentos'
        },
        {
          codigo: 'INFORMACOES_TITULO',
          descricao: 'Informação de título'
        },
        {
          codigo: 'OUTRO',
          descricao: 'Outro'
        }
      ],
      config: {
        lang: 'pt-BR',
        placeholder: 'Digite o texto...',
        minHeight: 200,
        height: 350,
        maxHeight: 350
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.input {
  width: 100%;
}
.marginTop {
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/solicitarInformacao/components/InformacaoDesejada.vue